import { useEffect, useRef } from "react";
import { HeightSyncHookProps } from "@/components/ui/category-summary/types";

export const useHeightSync = ({
  isComparisionMode,
  compareMode,
  overview,
}: HeightSyncHookProps) => {
  const overviewRef = useRef<HTMLDivElement>(null);

  // 概要の高さを測定し、親コンポーネントに通知
  useEffect(() => {
    if (
      isComparisionMode
      && overviewRef.current
      && compareMode?.onOverviewHeightChange
    ) {
      // 最小でも50pxの高さを確保
      const updateHeight = () => {
        if (overviewRef.current && compareMode?.onOverviewHeightChange) {
          // 一時的に高さ制約を解除して実際の高さを測定
          const originalStyle = overviewRef.current.style.height;
          const originalMinHeight = overviewRef.current.style.minHeight;

          // スタイルを一時的に解除
          overviewRef.current.style.height = "auto";
          overviewRef.current.style.minHeight = "0px";

          // 実際の高さを測定
          const height = Math.max(overviewRef.current.scrollHeight, 50);

          // 元のスタイルを復元
          overviewRef.current.style.height = originalStyle;
          overviewRef.current.style.minHeight = originalMinHeight;

          compareMode.onOverviewHeightChange(height);
        }
      };

      // 初期計算
      updateHeight();

      // ResizeObserverを作成して要素のサイズ変更を監視
      const resizeObserver = new ResizeObserver(() => {
        updateHeight();
      });

      // ウィンドウのリサイズイベントも監視
      const handleResize = () => {
        updateHeight();
      };
      window.addEventListener("resize", handleResize);

      // 監視を開始
      resizeObserver.observe(overviewRef.current);

      // クリーンアップ関数
      return () => {
        resizeObserver.disconnect();
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [
    isComparisionMode,
    compareMode,
    overview,
  ]);

  return {
    overviewRef,
  };
};
